$(document).ready(function() {
	if(!document.querySelector('.GPC0071')) return false;

	var $obj = $('.GPC0071');
	var ctaGetDlUseFlag = $('.GPC0071').attr('data-cta-dl-flag') == 'N' ? false : true; // LGEGMC-1145
	var waNumber = 0;
	$obj.find('.unit-box').each(function() {
		var $target;
		if($(this).find('.title') && !$(this).find('.title').is(':empty')) {
			$target = $(this).find('.title');
		}
		if($target) {
			$target.attr('id', 'waGPC0071_'+waNumber);
			$(this).find('a.btn').attr('aria-describedby', 'waGPC0071_'+waNumber);
			$(this).find('a.link-text').attr('aria-describedby', 'waGPC0071_'+waNumber);
			waNumber++;
		}
	});
	
	// LGEGMC-1094, LGEGMC-1145
	$('.GPC0071').find('div.cta-box a').on("click",function(e){
		
		/* LGECN-214 Start */
		if(lgCggroupName == 'home' && COUNTRY_CODE.toLowerCase() == 'cn' && typeof _hmt != 'undefined'){
			var $clickContent = $(this).parents('.unit-box').find('.title').text();
	    	console.log('[Baidu trackEvent] [Homepage_View More] ', ', $lg_cggroup : '+ $lg_cggroup, ', $clickContent : '+$clickContent);
	    	_hmt.push(['_trackEvent',$lg_cggroup,'Click '+$clickContent,'Homepage_View More']); 
		}
		/* LGECN-214 End */
		
		if(ctaGetDlUseFlag){
			var urlPath = $(this).attr('href');
			urlPath = urlPath.split(/[?#]/)[0];
			
			var lastIndex = urlPath.indexOf("/", urlPath.length-1);
			if (lastIndex !== -1) {
				urlPath = urlPath.substring(0, lastIndex);
			}
			
			var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/getDataLayerByUrl?urlPath='+urlPath;
			$.ajax({
				type:"post",
				url: url,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					if ( data.data[0].dataLayer != null ) {
						_dl["page_name"].super_category = data.data[0].dataLayer.superCategory;
						_dl["page_name"].category = data.data[0].dataLayer.category;
						_dl["products"].model_code = data.data[0].dataLayer.modelCode;
						_dl["products"].model_name = data.data[0].dataLayer.modelName;
						_dl["products"]._sales_model_code = data.data[0].dataLayer.salesModelCode;
						
						console.log("superCategory : " + _dl["page_name"].super_category);
						console.log("category : " + _dl["page_name"].category);
						console.log("modelCode : " + _dl["products"].model_code);
						console.log("modelName : " + _dl["products"].model_name);
						console.log("_salesModelCode : " + _dl["products"]._sales_model_code);
					} else {
						console.log("data.data[0].dataLayer : null");
					}
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);
				}
			});
		
		}
	});
	// LGEGMC-1094, LGEGMC-1145 End
	
});